
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage_boats",
      function () {
        return require("private-next-pages/manage_boats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage_boats"])
      });
    }
  